import { CheckCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useKeycloakAuth } from '@/contexts/keycloak-auth-context';

export function RegistrationSuccess() {
  const { login } = useKeycloakAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  const justRegistered = searchParams.get('registered') === 'true';

  useEffect(() => {
    // If not coming from registration, redirect to home
    if (!justRegistered) {
      navigate('/', { replace: true });
      return;
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          login(); // Auto-trigger login when countdown reaches 0
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [justRegistered, login, navigate]);

  const handleLoginNow = () => {
    login();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-black p-4">
      <div className="w-full max-w-md text-center">
        {/* Success Icon */}
        <div className="mb-8 flex justify-center">
          <div className="rounded-full bg-green-500/10 p-4">
            <CheckCircle className="h-16 w-16 text-green-500" strokeWidth={2} />
          </div>
        </div>

        {/* Success Message */}
        <h1 className="mb-4 text-4xl font-bold text-white">Registration successful!</h1>

        <p className="mb-8 text-lg text-gray-400">
          Your account has been created. You will be redirected to the login page shortly.
        </p>

        <p className="mb-8 text-sm text-gray-500">
          Redirecting in <span className="font-bold text-green-500">{countdown}</span> seconds...
        </p>

        {/* Login Button */}
        <Button
          onClick={handleLoginNow}
          size="lg"
          className="mb-12 w-full bg-green-600 text-lg font-semibold text-white hover:bg-green-700"
        >
          Continue to Login Now
        </Button>

        {/* Footer */}
        <p className="text-sm text-gray-600">SteerFi</p>
      </div>
    </div>
  );
}
